"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiFab = getMuiFab;
var _styles = require("@mui/material/styles");
function getMuiFab(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required',
      disableFocusRipple: true,
      disableRipple: true,
      size: 'medium'
    },
    styleOverrides: {
      root: {
        '&:hover': {
          backgroundColor: palette.info.main
        },
        '&:visited': {
          backgroundColor: palette.grey.A700,
          boxShadow: "0px 14px 20px ".concat((0, _styles.alpha)(palette.common.black, 0.13))
        },
        '.MuiSvgIcon-root': {
          height: '24px',
          width: '24px'
        },
        backgroundColor: palette.info.main,
        boxShadow: '0px 14px 20px rgba(0, 0, 0, 0.13)',
        color: palette.common.white
      },
      sizeMedium: {
        height: '80px',
        width: '80px'
      },
      sizeSmall: {
        '&:active': {
          boxShadow: 'none'
        },
        boxShadow: 'none',
        height: '60px',
        width: '60px'
      }
    }
  };
}